export const PlantViewOptions = {
  REGIONAL_STRUCTURE: 'regionalStructure',
  PLANT_LIST: 'plantList'
} as const

export type PlantViewOption = (typeof PlantViewOptions)[keyof typeof PlantViewOptions]

export const PLANT_VIEWS = Object.values(PlantViewOptions) as PlantViewOption[]
